module.exports = __webpack_public_path__ + "img/wechat.dd899a1a.png";